import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import localHub from "../../Assets/Projects/localhub.png";
import copDb from "../../Assets/Projects/copdb.png";
import mirkoHubTvChat from "../../Assets/Projects/mirkohubtvchat.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={localHub}
              isBlog={false}
              title="Local Hub"
              description="Local Hub is your manager for local businesses! The bot tracks sales, employee earnings, and more. It can optimize your business! Features include managing invoices, setting hourly and percentage earnings, tracking expenses, generating charts of top sellers, and much more. It also monitors inactive users and provides a detailed log of all activities."
              ghLink="https://lh.mirkohubtv.it"
              demoLink="https://discord.com/oauth2/authorize?client_id=1205213949650534432"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={copDb}
              isBlog={false}
              title="Cop DB"
              description="Cop DB is the ultimate manager for law enforcement! This bot simplifies arrests, weapon license tracking, and more. Designed for roleplay servers on FiveM, it allows officers to manage operations in-game, providing a comprehensive database for police forces."
              ghLink="https://lh.mirkohubtv.it"
              demoLink="https://discord.com/oauth2/authorize?client_id=1205213949650534432"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={mirkoHubTvChat}
              isBlog={false}
              title="MirkoHubTV Chat"
              description="MirkoHubTV Chat is a self-hosted communication platform, similar to Discord, built as a modified fork of Revolt. It features numerous customizations to improve user experience and provide a unique chat environment."
              ghLink="https://chat.mirkohubtv.it"
              demoLink="https://chat.mirkohubtv.it/invite/MirkoHubTV"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
